<template>
	<BaseCmsPage v-slot="{page}">
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>	
		<div class="main">
			<div class="wider-wrapper">
				<ClientOnly>
					<BaseAuthForgottenPasswordForm class="form-animated-label" v-slot="{fields, loading, status, urls}">
						<div v-if="status && status?.success" class="global-success"><BaseCmsLabel :code="status.data?.label_name" /></div>

						<template v-if="!status || (status && !status.success)">
							<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
								<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}]">
									<BaseFormInput />
									<BaseCmsLabel tag="label" :for="item.name" :code="item.name" />
									<span class="error" v-show="errorMessage" v-html="errorMessage" />
								</p>
							</BaseFormField>
							<div class="lr-btn-pw">
								<button type="submit" class="btn btn-primary" :class="{'loading': loading}"><UiLoader v-if="loading" /><span><BaseCmsLabel code="send" /></span></button>
								<div class="links">
									<NuxtLink class="back" :to="urls.auth_login"><span><BaseCmsLabel code="back_to_login" /></span></NuxtLink>
									<NuxtLink class="signup" :to="urls.auth_signup"><span><BaseCmsLabel code="add_new_account" /></span></NuxtLink>
								</div>
							</div>
						</template>
					</BaseAuthForgottenPasswordForm>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</div>
		</div>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	:deep(.bc){display: none;}
	:deep(.intro-container-inner){padding: 103px 0 25px;}
	.wider-wrapper{display: block; max-width: 460px; padding: 30px 0 60px; margin: auto;}
	h1{text-align: center;}
	.links{display: flex; flex-flow: column; font-size: 16px; line-height: 22px; align-items: center; justify-content: center; flex-grow: 1;
 		a{text-decoration: underline !important;}
	}

	@media (max-width: @t){
		:deep(.intro-container-inner){padding: 40px 0 12px;}
	}
	@media (max-width: @m){
		.wider-wrapper{max-width: none; margin: 0 15px;}
		.links{font-size: 14px; line-height: 18px;}		
	}
</style>